import identity from "ramda/es/identity";
import pathOr from "ramda/es/pathOr";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../constants';
/**
 * get iasc id
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getIascId(state)
 *
 */ export const getIascId = createSelector(pathOr({}, [
    REDUCER_NAME,
    'id'
]), identity);
/**
 * get iasc data
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getIascData(state)
 *
 */ export const getIascData = createSelector(pathOr({}, [
    REDUCER_NAME,
    'data'
]), identity);
